<template>
	<div id="app">
		<Menu />
		<transition
			name="fade"
			mode="out-in"
		>
			<router-view class="content" />
		</transition>
		<Footer />
	</div>
</template>
<script>
	import Menu from './components/Menu';
	import Footer from './components/Footer';

	export default {
		name: 'App',
		components: {
			Menu,
			Footer
		}
	};
</script>
<style lang="less">
	@import "~normalize.css";
	body, html {
		padding: 0;
		margin: 0;
		width: 100%;
		height: 100%;
	}
	* {
		box-sizing: border-box;
	}
	#app {
		font-family: sans-serif;
		line-height: 1.4;
		text-align: center;
		color: #2c3e50;
		display: flex;
		flex-direction: column;
		height: 100%;
	}
	.content{
		padding: 15px;
		max-width: 960px;
		width: 100%;
		margin: 0 auto;
		box-sizing: border-box;
		flex-grow: 1;
		text-align: left;
	}
	.big-logo{
		max-width: 511px;
		width: 100%;
		display: block;
		margin: 0 auto;
	}

	.fade-enter-active, .fade-leave-active {
		transition: all .5s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
		transform: translateY(30px);
	}
	a:visited{
		color: #fa5255;
	}
	a{
		color: #fa5255;
		text-decoration: none;
		&:hover{
			color: #ff0a00;
		}
	}
</style>
